// Mock data for Petroservice website

export const companyInfo = {
  name: "Petroservice",
  established: 2014,
  headquarters: {
    location: "Belarus",
    address: "Minsk, Republic of Belarus",
    phone: "+375 222 65 36",
    email: "info@petroservice.by"
  },
  branch: {
    location: "Syria",
    address: "Damascus, Syrian Arab Republic",
    phone: "+963 XX XXX XXXX",
    email: "syria@petroservice.by"
  },
  logo: "images/logo_no_bg.png"
};

export const statistics = {
  yearsActive: 9,
  dryPlaceAccuracy: "+25",
  millionsSaved: "+50M",
  countriesOperating: 5
};

export const operatingCountries = [
  { name: "Belarus", coordinates: { lat: 53.9, lng: 27.57 } },
  { name: "Kazakhstan", coordinates: { lat: 48.02, lng: 66.92 } },
  { name: "Russia (Krasnodar)", coordinates: { lat: 45.04, lng: 38.98 } },
  { name: "Russia (Samara)", coordinates: { lat: 53.2, lng: 50.15 } },
  { name: "Syria", coordinates: { lat: 34.8, lng: 38.99 } }
];

export const images = {
  hero: "./images/home_page.gif",
  heroVideo: "./images/home_page.mp4",
  drilling: "./images/photo-1696059928249-f036c4d54338.png",
  offshore: "./images/pexels-photo-3207536.png",
  // equipment: "https://images.unsplash.com/photo-1646956141271-05281b4ef472?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHxzY2llbnRpZmljJTIwZXF1aXBtZW50fGVufDB8fHx8MTc2NTI3NDYzMnww&ixlib=rb-4.1.0&q=85",
  // scientific: "https://images.pexels.com/photos/2280547/pexels-photo-2280547.jpeg",
  refinery: "./images/photo-1516937941344-00b4e0337589.png",
  homescan: "./images/land1.png",
  servland: "./images/land2.png"
};

export const certifications = [
  {
    id: 1,
    title: "Council of Ministers of Belarus",
    description: "Official recommendation for national exploratory works",
    year: 2018
  },
  {
    id: 2,
    title: "Ministry of Oil - Syria",
    description: "Resolution No. 6135 - Qualified to operate in Syrian territory",
    year: 2019
  }
];

export default {
  companyInfo,
  statistics,
  operatingCountries,
  images,
  certifications
};